<template>
  <v-container class="my-0 py-1" fluid>
    <v-dialog v-model="desinstalarDlg" width="500" v-if="selected.id">
      <v-card>
        <v-card-title>Desinstalar carga</v-card-title>
        <form @submit.prevent="desinstalar">
          <v-card-text>
            <span>Está a punto de desinstalar la carga '{{ selected.name.toUpperCase() }}', esta acción es irreversible. Por favor especifique los motivos detallados de la desinstalación</span>
            <v-divider class="my-3"></v-divider>
            <v-textarea
              label="Motivo desinstalación"
              outlined
              required
              no-resize
              v-model="desinstalacion.motivo"
              hide-details
            ></v-textarea>
            <v-menu
              ref="desinstalacionPicker"
              v-model="desinstalacionPicker"
              :close-on-content-click="false"
              :return-value.sync="desinstalacion.fecha"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="desinstalacion.fecha"
                  label="Fecha desinstalación"
                  readonly
                  outlined
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="desinstalacion.fecha" no-title scrollable :max="today">
                <div class="flex-grow-1"></div>
                <v-btn text color="primary" @click="desinstalacionPicker = false">Cancel</v-btn>
                <v-btn text color="primary" @click="$refs.desinstalacionPicker.save(desinstalacion.fecha)">OK</v-btn>
              </v-date-picker>
            </v-menu>
            <v-card-actions>
              <div class="flex-grow-1"></div>
              <v-btn type="submit" color="success">Desinstalar</v-btn>
            </v-card-actions>
          </v-card-text>
        </form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="createUpdate" width="500" persistent>
      <v-card>
        <v-card-title>{{ selected.id ? 'Editar' : 'Crear' }} Carga</v-card-title>
        <form @submit.prevent="createOrUpdate">
          <v-card-text>
            <v-row>
              <v-col>
                <v-text-field v-model="selected.name" label="Nombre" outlined required></v-text-field>
              </v-col>
              <v-col>
                <v-text-field v-model="selected.voltage" type="number" label="Voltaje" outlined required></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="selected.relacion_ct"
                  type="number"
                  label="Relación CT"
                  outlined
                  required
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="selected.factor_potencia"
                  type="number"
                  label="Factor Potencia"
                  outlined
                  step="any"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-select
                  outlined
                  label="Tipo circuito"
                  :items="tipos_circuito"
                  item-text="text"
                  item-value="value"
                  v-model="selected.tipo_circuito"
                  required
                ></v-select>
              </v-col>
              <v-col>
                <v-select
                  outlined
                  label="Tipo medida"
                  :items="tipos_medida"
                  item-text="text"
                  item-value="value"
                  v-model="selected.tipo_medida"
                  required
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-select
                  outlined
                  label="Medidor"
                  :items="meters"
                  item-text="concentrator_id"
                  item-value="id"
                  v-model="selected.meter"
                ></v-select>
              </v-col>
              <v-col>
                <v-select
                  outlined
                  label="Centro de operación"
                  :items="cecos"
                  item-text="name"
                  item-value="id"
                  v-model="selected.ceco"
                  required
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  outlined
                  label="Factor multiplicación"
                  type="number"
                  v-model="selected.factor_multiplicacion"
                  step="any"
                  required
                ></v-text-field>
              </v-col>
              <v-col>
                <v-menu
                  ref="picker"
                  v-model="picker"
                  :close-on-content-click="false"
                  :return-value.sync="selected.fecha_instalacion"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="selected.fecha_instalacion"
                      label="Fecha de instalación"
                      readonly
                      outlined
                      v-on="on"
                      required
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="selected.fecha_instalacion"
                    no-title
                    scrollable
                    :max="today"
                  >
                    <div class="flex-grow-1"></div>
                    <v-btn text color="primary" @click="picker = false">Cancel</v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.picker.save(selected.fecha_instalacion)"
                    >OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="success" type="submit">Guardar</v-btn>
            <v-btn color="error" @click="createUpdate = false">Cancelar</v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col class="col-3">
        <v-text-field
          placeholder="Buscar carga..."
          v-model="search"
          append-icon="search"
          single-line
        ></v-text-field>
      </v-col>
      <v-col class="text-right">
        <v-btn color="primary" @click="selected = {}; getMeters(); getCargas(); createUpdate = true">Crear nueva carga</v-btn>
      </v-col>
    </v-row>
    <v-data-table :headers="headers" :items="cargasM" :items-per-page="5" :search="search">
      <template v-slot:item.name="{ item }">{{ item.name.toUpperCase() }}</template>
      <template v-slot:item.relacion_ct="{ item }">{{ item.relacion_ct }}/5</template>
      <template v-slot:item.acciones="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              small
              text
              color="primary"
              v-on="on"
              @click="selected = item; createUpdate = true"
            >
              <i class="fa fa-pencil"></i>
            </v-btn>
          </template>
          <span>Editar</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              small
              text
              color="warning"
              v-on="on"
              @click="selected = item; desinstalarDlg = true"
            >
              <i class="fa fa-chain-broken"></i>
            </v-btn>
          </template>
          <span>Desisntalar</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn small text color="error" v-on="on" @click="deleteCarga(item)">
              <i class="fa fa-trash"></i>
            </v-btn>
          </template>
          <span>Eliminar</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import Vue from "vue";
import { API } from "../../../globals";
import { Auth } from "../../../classes/Auth";

import moment from "moment";
import { apiv1 } from "../../../libs/apiv1";

const auth = new Auth();
const today = moment().format("YYYY-MM-DD HH:mm:ss");

export default Vue.extend({
  name: "Carga",
  data: () => ({
    headers: [
      { text: "Nombre", value: "name" },
      { text: "Voltaje", value: "voltage" },
      { text: "Relación CT", value: "relacion_ct" },
      { text: "Factor potencia", value: "factor_potencia" },
      { text: "Fecha de instalación", value: "fecha_instalacion" },
      {
        text: "Acciones",
        value: "acciones",
        align: "center",
        sortable: false,
        width: 200
      }
    ],
    today: moment().format("YYYY-MM-DD"),
    selected: {},
    createUpdate: false,
    cargas: [],
    search: null,
    tipos_medida: [
      { text: "Directa", value: "D" },
      { text: "Indirecta", value: "I" }
    ],
    tipos_circuito: [
      { text: "Trifásico", value: "T" },
      { text: "Bifásico", value: "B" },
      { text: "Monofásico", value: "M" }
    ],
    meters: [],
    cecos: [],
    picker: false,
    desinstalarDlg: false,
    desinstalacion: {
      fecha: today
    },
    desinstalacionPicker: false
  }),
  computed: {
    cargasM: function() {
      return this.cargas.map(function(item) {
        item.fecha_instalacion = moment(
          new Date(item.fecha_instalacion)
        ).format("YYYY-MM-DD");
        return item;
      });
    }
  },
  mounted() {
    this.getCargas();
    this.getCecos();
    this.getMeters();
  },
  methods: {
    getCargas: function() {
      apiv1.get(`cargas?project=${auth.getProject().id}`)
      .then(res => (this.cargas = res.data));
    },
    getMeters: function() {
      apiv1.get(`meters?disponibles=true`)
      .then(res => {
        this.meters = res.data;
      });
    },
    getCecos: function() {
      apiv1.get(`cecos?project=${auth.getProject().id}`)
      .then(res => {
        this.cecos = res.data;
      });
    },
    createOrUpdate: function() {
      let url = `cargas`;
      let method = "POST";
      if (this.selected.id) {
        url += "/" + this.selected.id;
        method = "PUT";
      }
      apiv1({
        method: method,
        "url": url,
        data: this.selected
      })
      .then(res => {
        this.getCargas();
        this.createUpdate = false;
        this.selected = {};
        this.$awn.success(res.data);
      })
      .catch(err => this.$awn.alert(err.response.data));
    },
    deleteCarga: function(item){
      this.$swal({
        title: "Continuar?",
        text: `¿Seguro que desea eliminar la carga '${item.name.toUpperCase()}'?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, deseo eliminarla",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true
      }).then(result => {
        if(result.value){
          apiv1.delete(`cargas/${item.id}`)
        .then(res => {
          this.selected = {};
          this.getCargas();
          this.$awn.success(res.data);
        })
        }
      });
    },
    desinstalar: function() {
      apiv1.put(`cargas/desinstalar/${this.selected.id}`,{
          desinstalacion: this.desinstalacion,
          user: auth.getUser().id
        })
        .then(res => {
        this.getCargas();
        this.desinstalarDlg = false;
        // this.desinstalacion = {};
        this.selected = {};
        this.$awn.success(res.data)
      });
    }
  }
});
</script>

<style>
</style>